import { useState, useEffect, useCallback } from "react";
import { supabase } from "../supabaseClient";

export const usePendingAdjustments = (enabled = true) => {
  const [count, setCount] = useState(0);

  const fetchCount = useCallback(async () => {
    if (!enabled) return;
    // head:true + count:'exact' returns only the count, no rows
    const { count: c, error } = await supabase
      .from("stat_adjustment_requests")
      .select("id", { count: "exact", head: true })
      .eq("status", "pending");
    if (!error) setCount(c ?? 0);
  }, [enabled]);

  useEffect(() => {
    fetchCount();

    if (!enabled) return;
    // Realtime: bump/refresh the badge the instant a row changes
    const channel = supabase
      .channel("pending-adjustments")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "stat_adjustment_requests" },
        () => fetchCount(),
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [enabled, fetchCount]);

  return count;
};
